module.exports = __webpack_public_path__ + "img/oil-life.ea7977eb.png";